import { IAction } from '../utils';
import { AlertType, reducerTypes } from './types';

export const INITIAL: AlertType = {
  active: false,
  text: '',
  description: '',
  header: '',
  noIcon: false,
  isPrompt: false,
  errorType: false,
};

export const alertReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.TOGGLE_ALERT:
      return {
        active: !state.active,
        text: payload?.text,
        isPrompt: payload?.isPrompt,
        onApprove: payload?.onApprove,
        header: payload?.header,
        noIcon: payload?.noIcon,
        delay: payload?.delay,
        onDecline: payload?.onDecline,
        description: payload?.description,
        errorType: payload?.errorType,
      };
    case reducerTypes.CLOSE_ALERT:
      return { active: false, text: '' };
    default:
      return state;
  }
};
